module.exports = __webpack_public_path__ + "static/media/gasoline-banesco.5d56a00c.svg";